import uniqid from 'uniqid'
import { useContext } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { LanguageContext } from '../../contexts/language'
import content from '../../portfolio'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

const Projects = () => {
  const { language } = useContext(LanguageContext)
  const { projects } = content[language]
  const labels = {
    de: 'Projekte',
    en: 'Projects'
  }
  
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  if (!projects.length) return null

  return (
    <section id='projects' className='section projects'>
      <motion.h2 
        ref={ref}
        className='section__title'
        initial={{ opacity: 0, y: -20 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
      >
        {labels[language]}
      </motion.h2>

      <div className='projects__grid'>
        {projects.map((project) => (
          <ProjectContainer key={uniqid()} project={project} />
        ))}
      </div>
    </section>
  )
}

export default Projects
